import React, { useMemo } from "react";
import moment from 'moment';
import { useTranslate } from "lib/translate";
import { Expandable } from '@haldor/ui';
import './_blockPurpose.scss';

var BlockPurpose = function BlockPurpose(props) {
  var translate = useTranslate();
  var purposeData = useMemo(function () {
    var value = props.assessmentBlocks;

    if (value == null || value.length == 0) {
      return [];
    }

    var data = [];
    var blocks = value.filter(function (b) {
      return b.type === 'Haldor.Blocks.AssessmentBlock';
    });
    blocks.forEach(function (items) {
      var resources = items.resources.filter(function (s) {
        return s["@odata.type"] === 'Haldor.Blocks.AssessmentBlockPart' && s.referenceType === 'matrix';
      });

      if (resources) {
        resources.forEach(function (resource) {
          var course = JSON.parse(JSON.stringify(resource));
          var inData = data.find(function (r) {
            var _r$value, _course$value;

            return ((_r$value = r.value) === null || _r$value === void 0 ? void 0 : _r$value.id) == ((_course$value = course.value) === null || _course$value === void 0 ? void 0 : _course$value.id);
          });

          if (inData == null) {
            var _course$value2;

            var details = course === null || course === void 0 ? void 0 : (_course$value2 = course.value) === null || _course$value2 === void 0 ? void 0 : _course$value2.details.filter(function (x) {
              return x.endDate == null || moment(x.endDate).isAfter(moment());
            });
            course.value.details = details;
            data.push(course);
          }
        });
      }
    });
    return data;
  }, [props.assessmentBlocks]);
  return /*#__PURE__*/React.createElement("div", {
    className: "blockPurpose"
  }, purposeData.length > 0 ? purposeData.map(function (items, index) {
    var _items$value, _items$value$year, _items$value2, _items$value3, _items$value$colorCod, _items$value4;

    return /*#__PURE__*/React.createElement(Expandable, {
      title: "".concat((_items$value = items.value) === null || _items$value === void 0 ? void 0 : _items$value.title, " ").concat((_items$value$year = (_items$value2 = items.value) === null || _items$value2 === void 0 ? void 0 : _items$value2.year) !== null && _items$value$year !== void 0 ? _items$value$year : '', " (").concat((_items$value3 = items.value) === null || _items$value3 === void 0 ? void 0 : _items$value3.courseCode, ")"),
      color: (_items$value$colorCod = items === null || items === void 0 ? void 0 : (_items$value4 = items.value) === null || _items$value4 === void 0 ? void 0 : _items$value4.colorCode) !== null && _items$value$colorCod !== void 0 ? _items$value$colorCod : '#e4e4eb',
      key: index,
      whiteBackground: true
    }, items.value.details.map(function (items, index) {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "purposeContent",
        dangerouslySetInnerHTML: {
          __html: items.purpose
        }
      });
    }));
  }) : /*#__PURE__*/React.createElement("p", null, translate('No knowledge requirements selected')));
};

export default BlockPurpose;